import { render, staticRenderFns } from "./freeShipping.vue?vue&type=template&id=c34ac832&scoped=true&"
import script from "./freeShipping.vue?vue&type=script&lang=ts&"
export * from "./freeShipping.vue?vue&type=script&lang=ts&"
import style0 from "./freeShipping.vue?vue&type=style&index=0&id=c34ac832&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34ac832",
  null
  
)

export default component.exports